import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { updateAccountPolicy } from './form.thunks';

export interface AccountPolicyFormState {
  loading: boolean;
  error: string | null;
}

export const initialState: AccountPolicyFormState = {
  error: null,
  loading: false
};

export const selectors = {};

const extraReducers = {
  [updateAccountPolicy.pending.type]: (state: AccountPolicyFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [updateAccountPolicy.fulfilled.type]: (state: AccountPolicyFormState): void => {
    state.loading = false;
  },
  [updateAccountPolicy.rejected.type]: (state: AccountPolicyFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const AccountPolicyFormSlice = createSlice({
  name: 'AccountPolicyForm',
  initialState,
  reducers: {},
  extraReducers
});

export default AccountPolicyFormSlice.reducer;

export const actions = AccountPolicyFormSlice.actions;
export const caseReducers = AccountPolicyFormSlice.caseReducers;